module.exports = __webpack_public_path__ + "static/media/exercise.2d534bf2.svg";